<section
    class="nw-content-block__container"
    [class.nw-content-block__container--border]="border"
    [class.nw-content-block__container--transparent]="transparentBackground"
>
    @if (heading) {
        <h2 class="nw-content-block__container__heading">{{ heading }}</h2>
    }
    @if (subheading) {
        <p class="nw-content-block__container__subheading">{{ subheading }}</p>
    }
    <div class="nw-content-block__container__content">
        @if (cards?.length) {
            <div
                class="nw-content-block__container__content__cards"
                [style.gridTemplateColumns]="'repeat(' + cards?.length + ', 1fr)'"
            >
                @for (card of cards; track $index) {
                    <div class="nw-content-block__container__content__cards__card">
                        <h4
                            class="nw-content-block__container__content__cards__card__header"
                        >
                            {{ card.header }}
                        </h4>
                        <div
                            class="nw-content-block__container__content__cards__card__body"
                        >
                            {{ card.body }}
                        </div>
                    </div>
                }
            </div>
        }
        <ng-content></ng-content>
        <div [innerHTML]="content | sanitizeHtml"></div>
    </div>
</section>
